<p-toast position="top-center"></p-toast>
<form [formGroup]="formulario" (ngSubmit)="salvar()">
  <div class="p-grid">
      
      <div class="p-col-2" >
          <span style="font-weight: bolder">Título do Documento* </span> <br>
          <input  formControlName="titulo" type="text" style="width:100%"  pInputText> 
          
        
          <div class="has-error" *ngIf="verificaValidTouched('titulo')">Campo obrigatório</div> 
      </div>

      <div class="p-col-2" >
        <span style="font-weight: bolder">Data* </span> <br>
        <input  formControlName="dia" style="width:100%" type="date"  pInputText> 
        
      
        <div class="has-error" *ngIf="verificaValidTouched('dia')">Campo obrigatório</div> 
    </div>

      <div class="p-col-3" > 
        <div *ngIf="!licitacaoKey">

        
          <span style="font-weight: bolder">Setor* </span> <br>
          <p-dropdown *ngIf="!personalizado" [options]="precat" [style]="{'width':'100%'}" formControlName="setor" (onChange)="mudouSetor()"></p-dropdown> 
          <input *ngIf="personalizado"  formControlName="categoria" style="width:100%"  pInputText>
        
          <div class="has-error" *ngIf="verificaValidTouched('categoria')">Campo obrigatório</div>
        </div>

        <div *ngIf="!licitacaoKey">

        
          <span style="font-weight: bolder">Categoria* </span> <br>
          <p-dropdown *ngIf="!personalizado" [options]="categorias" [style]="{'width':'100%'}" formControlName="categoria">
            <ng-template let-car pTemplate="item"> 
              <div *ngIf="car.label[0]=='*'" class="sub-item">
                {{car.label}}
              </div>
              <div *ngIf="car.label[0]!=='*'">
                {{car.label}}
              </div>
              
            </ng-template>
          </p-dropdown> 
          <input *ngIf="personalizado"  formControlName="categoria" style="width:100%"  pInputText>
        
          <div class="has-error" *ngIf="verificaValidTouched('categoria')">Campo obrigatório</div>
        </div>

        <div *ngIf="licitacao">
          <span style="font-weight: bolder;font-family: 'Roboto';">Processo Licitatório </span> <br>
          <span style="font-weight: bolder;font-family: 'Roboto';font-size: 18px;">{{licitacao.descricao}} </span><br>
          <button pButton type="button" pTooltip="Clique para voltar para tela anterior"  tooltipPosition="right" (click)="voltar()" label="Voltar" class="ui-button-rounded ui-button-danger" ></button>
        </div>
      </div>

      <div class="p-col-4" style="text-align: right;margin-top: 50px">
        <button pButton type="submit" label="Salvar Arquivo" class="ui-button-rounded ui-button-success"></button>
      </div>

      

      <div class="p-col-10">
          <span style="font-weight: bolder">Descrição do Documento* </span>
        
            
                <p-editor formControlName="descricao" [style]="{'height':'150px'}">
                    <p-header>
                        <span class="ql-formats">
                            <button class="ql-bold" aria-label="Bold"></button>
                            <button class="ql-italic" aria-label="Italic"></button>
                            <button class="ql-underline" aria-label="Underline"></button>
                        </span>
                    </p-header>
                </p-editor>
            
              
              <div class="has-error" *ngIf="verificaValidTouched('descricao')">Campo obrigatório</div>
         
          
      </div>

      <div class="p-col-10">
          
        <image-upload id="up" style="margin-top: 100px; " url="https://www.diviprev.mg.gov.br/controladores/upload2.php" (removed)="onRemoved($event)"
    (uploadFinished)="onUploadFinished($event)" (uploadStateChanged)="onUploadStateChanged($event)" [preview]="true"
    [extensions]="['jpeg','png','pdf','xlsx','xls']" buttonCaption="SELECIONAR ARQUIVO" dropBoxMessage="ARRASTE O ARQUIVO AQUI"
    clearButtonCaption="Remover" [ngClass]="customClass">
</image-upload>


</div>

      
      


  </div>
</form>



<div style="margin-top: 7px">
  

</div>

<app-lista-arquivos mostrarLinks="true" [categoria]="this.formulario.value.categoria" [acao]="acao" edicao="true" (editar)="editar($event)" (excluir)="excluirArquivo($event)"></app-lista-arquivos>




